export default __webpack_public_path__ + "static/textures-9de4d66c46a56b2474d7c211a5325ba8.png";